import React, { Component } from 'react';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import { SelectItem } from 'primereact/selectitem';
import LanguageUtil from '../../util/LanguageUtil';

class CustomSelect extends Component<Props, State> {
  public state = new State();

  render() {
    const {
      className,
      border = true,
      backgroundColor = '!bg-transparent',
      labelClassName = 'bg-white text-f-black-2',
      valueClassName = 'text-2xs',
      customSize = 'md',
      options,
      required,
      ...rest
    } = this.props;
    this.wrapOptions(options);
    return (
      <div className={`group w-full !bg-transparent font-formica relative ${this.getCustomSize(customSize)}`}>
        <Dropdown
          {...rest}
          required
          optionGroupTemplate={this.optionGroupTemplate}
          options={options}
          valueTemplate={this.valueTemplate}
          emptyMessage={<div className={'text-xs'}>{LanguageUtil.get({ id: 'common.label.noResultsFound', defaultMessage: 'No results found' })}</div>}
          className={`w-full text-2xs ${this.getCustomSize(customSize)} ${!border && '!border-none hover:!border-none'} ${backgroundColor} ${className} pr-3`}
        />
        <span className={`absolute left-2 -top-1.5 px-0.5 text-3xs flex  rounded-md  ${labelClassName} `}>
          {this.props?.label}
          {required && <h5 className={'text-red-700 text-xs ml-1'}>*</h5>}
        </span>
      </div>
    );
  }

  private getCustomSize = (size: string = 'md') => {
    switch (size) {
      case 'sm':
        return 'h-[28px]';
      case 'md':
        return 'h-[34px]';
      case 'lg':
        return 'h-[40px]';
    }
  };

  private optionGroupTemplate = (option: any) => {
    return <div className='text-2xs h-full flex justify-start ${textColor} items-center'></div>;
  };

  private valueTemplate = (props: any) => {
    return <div className={`${this.props.valueClassName}  w-full text-2xs`}>{props?.label}</div>;
  };

  private wrapOptions = (options: any) => {
    options?.forEach((o: SelectItem | any) => {
      if (o.className) o.className += 'flex items-center justify-start h-[25px] text-2xs';
      else o.className = 'flex items-center justify-start h-[34px] text-2xs';
      if (o.items && Array.isArray(o.items)) {
        this.wrapOptions(o.items);
      }
    });
  };
}

type Props = DropdownProps & {
  ghost?: boolean;
  label?: string;
  border?: boolean;
  customSize?: 'sm' | 'md' | 'lg';
  backgroundColor?: string;
  labelClassName?: string;
  valueClassName?: string;
};

class State {}

export default CustomSelect;
